// Qual estado de falha mostrar para um erro da API. Puro, testável.
//
// A ordem importa: o código de negócio vence o status. Dois 403 dizem coisas
// diferentes — "sem white label nenhum" pede ao admin vincular a loja; "sem
// permissão" pede o papel. E nenhum dos dois se resolve com retry.
import {
  hasApiErrorCode,
  hasStatusCode,
} from "@/lib/api-error"

export const FORBIDDEN_WHITE_LABEL_SCOPE =
  "FORBIDDEN_WHITE_LABEL_SCOPE"

export type FeedbackVariant =
  | "forbiddenScope"
  | "forbidden"
  | "notFound"
  | "error"

export const feedbackVariantOf = (
  error: unknown
): FeedbackVariant => {
  if (hasApiErrorCode(error, FORBIDDEN_WHITE_LABEL_SCOPE)) {
    return "forbiddenScope"
  }
  if (hasStatusCode(error, 403)) return "forbidden"
  if (hasStatusCode(error, 404)) return "notFound"
  return "error"
}
